/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {Map, List} from 'immutable';

class KeyboardPopup extends React.Component {

    state: State = {
        shift: false,
        error: false,
        value: ''
    };

    static propTypes = {
        validationReqex: React.PropTypes.string,
        errorMsg: React.PropTypes.string,
        defaultValue: React.PropTypes.string.isRequired,
        onSubmit: React.PropTypes.func.isRequired,
        onClose: React.PropTypes.func,
        label: React.PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);

        const {defaultValue} = this.props;

        this.onSubmit = this.onSubmit.bind(this);
        this.onClose = this.onClose.bind(this);

        this.keyMap = this.keyMap.bind(this);
        this.clickShift = this.clickShift.bind(this);
        this.clickSpace = this.clickSpace.bind(this);
        this.clickBackspace = this.clickBackspace.bind(this);
        this.clickDefault = this.clickDefault.bind(this);
        this.setVal = this.setVal.bind(this);
        this.isEnter = this.isEnter.bind(this);
        this.generateSpanButton = this.generateSpanButton.bind(this);
        this.generateEnterButton = this.generateEnterButton.bind(this);

        const defVal = !!defaultValue ? defaultValue : '';

        this.state = {
            value: defVal,
        };
    }

    valiate(value) {
        const {validationReqex} = this.props;
        if (!validationReqex) {
            return true;
        }

        let regex = new RegExp(validationReqex);
        return regex.test(value);

    }

    onClose() {
        const {onClose} = this.props;
        onClose();
    }

    onSubmit() {
        const {onSubmit} = this.props;
        const {value} = this.state;

        const trimmedValue = value.trim();

        if (this.valiate(trimmedValue)) {
            onSubmit(trimmedValue);
        } else {
            this.setState({error: true});
        }
    }

    setVal(key) {
        const {shift, value} = this.state;
        if (!!shift) {
            this.setState({shift: false});
        }

        let val = value;
        if (key === null) {
            val = val.slice(0, -1);
        } else {
            val = val.toString() + key.toString();
        }
        this.setState({value: val});
        if (!!shift) {
            this.setState({shift: false});
        }
    }

    clickShift() {
        const {shift} = this.state;
        this.setState({shift: !shift});
    }

    clickSpace() {
        this.setVal(' ');
    }

    clickBackspace() {
        this.setVal(null);
    }

    clickDefault(i) {
        const {shift} = this.state;
        const keyMap = this.keyMap();
        let key;
        if (shift) {
            key = !!keyMap.getIn([i, 'secondKey'])
                ? keyMap.getIn([i, 'secondKey'])
                : keyMap.getIn([i, 'firstKey']);
            if (key === 'undefined') {
                return;
            }
            if (key.match(/[a-z]/g)) {
                key = key.toUpperCase();
            }
        } else {
            key = keyMap.getIn([i, 'firstKey']);
        }
        if (key === 'undefined') {
            return;
        }

        this.setVal(key);
    }

    keyMap() {
        return List([
            Map({
                firstKey: '~',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '1',
                secondKey: '!',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '2',
                secondKey: '@',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '3',
                secondKey: '#',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '4',
                secondKey: '$',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '5',
                secondKey: '%',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '6',
                secondKey: '^',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '7',
                secondKey: '@',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '8',
                secondKey: '*',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '9',
                secondKey: '(',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '0',
                secondKey: ')',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '-',
                secondKey: '_',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '=',
                secondKey: '+',
                keyClass: 'color-white'
            }),
            Map({
                innerClass: 'view-s',
                keyClass: 'color-white',
                keySize: 'view-size-2',
                icon: 'backspace',
                keyAction: this.clickBackspace
            }),
            Map({
                keyClass: 'func no-char big-1',
                keySize: 'view-size-2'
            }),
            Map({
                firstKey: 'q',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'w',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'e',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'r',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 't',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'y',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'u',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'i',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'o',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'p',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '[',
                secondKey: '{',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: ']',
                secondKey: '}',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '\\',
                secondKey: '|',
                keyClass: 'color-white'
            }),
            Map({
                keySize: 'view-size-3'
            }),
            Map({
                firstKey: 'a',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 's',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'd',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'f',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'g',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'h',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'j',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'k',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'l',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: ';',
                secondKey: ':',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '\'',
                secondKey: '\"',
                keyClass: 'color-white'
            }),
            Map({
                innerClass: 'view-s',
                keyClass: 'color-greenLight enter',
                icon: 'enter',
                keySize: 'view-size-3'
            }),
            Map({
                keyClass: 'color-white shift keyboardClasic-key-shift',
                icon: 'long-arrow-alt-up',
                keySize: 'view-size-4',
                keyAction: this.clickShift
            }),
            Map({
                firstKey: 'z',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'x',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'c',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'v',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'b',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'n',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: 'm',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: ',',
                secondKey: '<',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '.',
                secondKey: '>',
                keyClass: 'color-white'
            }),
            Map({
                firstKey: '/',
                secondKey: '?',
                keyClass: 'color-white'
            }),
            Map({
                keyClass: 'color-white shift keyboardClasic-key-shift',
                icon: 'long-arrow-alt-up',
                keySize: 'view-size-4',
                keyAction: this.clickShift
            }),
            Map({
                keyClass: 'color-white',
                firstKey: ' ',
                keySize: 'view-size-space',
                keyAction: this.clickSpace
            }),
            Map({
                innerClass: 'view-white',
                keyClass: 'color-red close',
                icon: 'times',
                keySize: 'view-size-4',
                keyAction: this.onClose
            })
        ]);
    }

    isEnter(key) {
        return !!key.get('keyClass') && key.get('keyClass').indexOf('enter') > -1;
    }

    isClose(key) {
        return !!key.get('keyClass') && key.get('keyClass').indexOf('close') > -1;
    }

    generateEnterButton(key, i) {
        return (
            <div className={`keyboardClasic-key ${key.get('keySize')}`} key={`key-${i}`}>
                <div
                    className={`boxBtn text-l ${key.get('keyClass')}`}
                    onClick={this.onSubmit}>
                    <div className="boxBtn-inner">
                        {!!key.get('icon') &&
                        <svg className={`shape shape-${key.get('icon')} ${!!key.get('innerClass') ? key.get('innerClass') : ''}`}>
                          <use xlinkHref={`#shape-${key.get('icon')}`}></use>
                        </svg>
                        }
                        {!key.get('icon') && !!key.get('firstKey') &&
                        <span className={`${key.get('innerClass')}`}>{key.get('firstKey')}</span>
                        }
                    </div>
                </div>
            </div>
        );
    }

    generateCloseButton(key, i) {
        const {onClose} = this.props;
        if (typeof onClose !== 'undefined') {
            return (
                <div className={`keyboardClasic-key ${key.get('keySize')}`} key={`key-${i}`}>
                    <div
                        className={`boxBtn text-l ${key.get('keyClass')}`}
                        onClick={this.onClose}>
                        <div className="boxBtn-inner">
                            {!!key.get('icon') &&
                            <svg className={`shape shape-${key.get('icon')} ${!!key.get('innerClass') ? key.get('innerClass') : ''}`}>
                              <use xlinkHref={`#shape-${key.get('icon')}`}></use>
                            </svg>
                            }
                            {!key.get('icon') && !!key.get('firstKey') &&
                              <span className={`${key.get('innerClass')}`}>{key.get('firstKey')}</span>
                            }
                        </div>
                    </div>
                </div>
            );
        } else {
            return;
        }
    }

    generateSpanButton(key, i) {
        const action = !!key.get('keyAction')
            ? key.get('keyAction')
            : this.clickDefault;

        return (
          <div key={`key-${i}`} className={`keyboardClasic-key ${key.get('keySize')}`}>
            <div
                  className={`boxBtn text-l ${key.get('keyClass')}`}
                  onClick={() => action(i)}
            >
              {!!key.get('icon') &&
              <div className="boxBtn-inner">
                <svg className={`shape shape-${key.get('icon')} ${!!key.get('innerClass') ? key.get('innerClass') : ''}`}>
                  <use xlinkHref={`#shape-${key.get('icon')}`}></use>
                </svg>
              </div>
              }
              {!key.get('icon') && !!key.get('secondKey') &&
              <div className="boxBtn-inner">
                {!!key.get('firstKey') &&
                <span className="keyboardClasic-key-first">{key.get('firstKey')}</span>
                }
                {!!key.get('secondKey') &&
                <span className="keyboardClasic-key-second">{key.get('secondKey')}</span>
                }
              </div>
              }
              {!key.get('icon') && !key.get('secondKey') &&
              <div className="boxBtn-inner">
                {!!key.get('firstKey') &&
                <span className={`keyboardClasic-key-only ${key.get('innerClass')}`}>{key.get('firstKey')}</span>
                }
              </div>
              }
            </div>
          </div>
        );
    }

    render() {
        const keyMap = this.keyMap();
        const {shift, value, error} = this.state;
        const {label, errorMsg, onClose} = this.props;

        return (
            <div className="keyboardPanel">
                <div className="keyboardPanel-panel">
                    <div className="keyboardPanel-row">
                        <span className="keyboardPanel-label">{label}</span>
                        <input className="keyboardPanel-input" value={value} readOnly/>
                        {!!error &&
                        <div className="keyboardPanel-errors">
                            <div className="errors">
                                <ul>
                                    <li>{errorMsg}</li>
                                </ul>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            <div className="keyboardPanel-keyboard">
                <div className={`keyboardClasic ${shift ? 'shift' : ''}`}>
                    {keyMap.map((key, i) => {
                        if (this.isEnter(key)) {
                            {return this.generateEnterButton(key, i)}
                        } else if (this.isClose(key)) {
                            {return this.generateCloseButton(key, i)}
                        } else {
                            {return this.generateSpanButton(key, i)}
                        }
                    })}
                </div>
            </div>
            </div>
        );
    }
}

export default connect(state => ({}))(KeyboardPopup);



// WEBPACK FOOTER //
// ./src/browser/components/keyboard/KeyboardPopup.js